<template>
  <v-toolbar 
    v-bind="style.section"
    app
    dark >
    <v-toolbar-side-icon 
      class="ml-2 mx-0"
      @click="toogleSideMenu" />
    <v-btn 
      v-bind="style.section"
      depressed
      class="mx-0"
      @click="navigateTo({name: 'Home'})">
      {{ $t("site.title") }}
    </v-btn>
    <v-spacer/>
    <v-menu 
      offset-y 
      class="ml-0 mr-2">
      <v-btn 
        slot="activator"
        color="primary" 
        style="min-width:auto"
        left
        small
        dark >{{ $locale }}</v-btn>
      <v-list>
        <v-list-tile @click="$locale = 'en'">
          <v-list-tile-title>{{ $t('general.languages.english') }}</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="$locale = 'es'">
          <v-list-tile-title>{{ $t('general.languages.spanish') }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    <template v-if="currentUser">
      <span class="hidden-sm-and-down mr-2 pl-2">
        {{ cropName(currentUser.customDisplayName) }}
      </span>

      <v-menu 
        offset-y 
        class="mr-3">
        <v-btn 
          slot="activator"
          color="primary" 
          left
          icon
          small
          dark >
          <v-avatar 
            v-if="currentUser.photoURL"
            size="36px" 
            class="teal">
            <img 
              :src="currentUser.photoURL"
              :alt="cropName(currentUser.customDisplayName)" >
          </v-avatar>
          <v-avatar 
            v-else
            size="36px" 
            class="teal">
            <span class="white--text headline">{{ cropName(currentUser.customDisplayName).slice(0,1).toUpperCase() }}</span>
          </v-avatar>
        </v-btn>
        <v-list>
          <v-list-tile @click="userSignOut">
            <v-list-tile-title>{{ $t('page.authentication.logout') }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </template>
    <template v-else>
      <v-menu offset-y>
        <v-btn 
          slot="activator" 
          color="primary" 
          dark
          small>
          {{ $t('page.authentication.login') }}
        </v-btn>
        <v-list>
          <v-list-tile @click="loginGoogle">
            <v-list-tile-title>{{ $t('page.authentication.loginGoogle') }}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="loginFacebook">
            <v-list-tile-title>{{ $t('page.authentication.loginFacebook') }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </template>
  </v-toolbar>
</template>
<script>
import { mapState } from 'vuex'
import BaseMixin from '@/components/Dashboard/Mixin/BaseMixin'

export default {
  components: {},
  mixins: [BaseMixin],
  data() {
    return {
      dialogLogin: false,
    }
  },
  computed: {
    ...mapState({
      style: state => state.style.style,
    }),
  },
  watch: {},
  created() {},
  methods: {
    toogleSideMenu() {
      this.$store.dispatch('global/toogleSideMenu')
    },
    userSignOut() {
      this.$store.dispatch('user/logout')
    },
    cropName(string) {
      if (string.indexOf('@') > -1) {
        string = string.slice(0, string.indexOf('@'))
      }
      const numMaxCharacters = 15
      if (string.length > numMaxCharacters) {
        return string.slice(0, numMaxCharacters) + '...'
      }
      return string
    },
    navigateTo(to) {
      this.$router.push(to)
    },
    loginGoogle() {
      this.$store.dispatch('user/loginGoogle')
    },
    loginFacebook() {
      this.$store.dispatch('user/loginFacebook')
    },
  },
}
</script>

<style lang="scss">
.alert {
  display: inline-block;
  width: 100%;
}
</style>
